import React from "react";
import { Link } from "react-router-dom";
import { Container } from "components";
import "./DashboardDemo.css";

const DashboardDemo = () => {
    return (
        <Container>
            <div className="dd-wrapper">
                {/* Greeting Row */}
                <div className="dd-greeting-row">
                    <div className="dd-greeting-left">
                        <h2 className="dd-hello">Hello, Channesh 👋</h2>
                        <p className="dd-city">
                            City: Bangalore{" "}
                            <span className="dd-city-arrow">&#x2304;</span>
                        </p>
                        <p className="dd-city-hint">Used to show nearby partners</p>
                    </div>
                    <div className="dd-alert-box">
                        <span className="dd-alert-icon">&#9651;</span>
                        <span className="dd-alert-text">
                            Important: Your password has not been changed in 90 days
                        </span>
                        <Link to="/setPassword" className="dd-update-link">
                            Update now
                        </Link>
                    </div>
                </div>

                {/* Renewal Banner */}
                <div className="dd-renewal-banner">
                    <span className="dd-renewal-text">
                        Renew early to avoid interruption of benefits
                    </span>
                    <button className="dd-renew-btn">Renew now</button>
                </div>

                {/* Main Grid */}
                <div className="dd-grid">
                    {/* Left Column */}
                    <div className="dd-col-left">
                        {/* Plan Card */}
                        <div className="dd-card">
                            <h3 className="dd-card-title">Family &amp; Friends Plan (3 Members)</h3>
                            <div className="dd-plan-status-row">
                                <span className="dd-active-badge">
                                    Active <span className="dd-check">&#10003;</span> Valid till 31 Dec 2026
                                </span>
                                <span className="dd-member-count">
                                    <span className="dd-member-icon">&#x2B07;</span> 2 / 3
                                </span>
                            </div>
                            <div className="dd-plan-actions">
                                <button className="dd-outline-btn">Download Cards</button>
                                <button className="dd-outline-btn">Manage Members</button>
                            </div>
                            <button className="dd-primary-btn dd-renew-membership-btn">
                                Renew Membership
                            </button>
                        </div>

                        {/* Family Members Card */}
                        <div className="dd-card">
                            <h3 className="dd-card-title">My Family Members</h3>
                            <div className="dd-member-list">
                                <div className="dd-member-item">
                                    <img
                                        className="dd-member-avatar"
                                        src="https://i.pravatar.cc/40?img=11"
                                        alt="Chamesh"
                                    />
                                    <div className="dd-member-info">
                                        <span className="dd-member-name">
                                            Chamesh <span className="dd-member-tag">(Primary)</span>
                                        </span>
                                        <span className="dd-member-status">Active</span>
                                    </div>
                                    <button className="dd-card-link-btn">
                                        <span className="dd-card-icon">&#8801;</span>
                                        <span className="dd-card-label">Download Card</span>
                                    </button>
                                </div>
                                <div className="dd-member-divider" />
                                <div className="dd-member-item">
                                    <img
                                        className="dd-member-avatar"
                                        src="https://i.pravatar.cc/40?img=52"
                                        alt="Dhatri"
                                    />
                                    <div className="dd-member-info">
                                        <span className="dd-member-name">Dhatri</span>
                                        <span className="dd-member-status">Active</span>
                                    </div>
                                    <button className="dd-card-link-btn">
                                        <span className="dd-card-icon">&#8801;</span>
                                        <span className="dd-card-label">Download Card</span>
                                    </button>
                                </div>
                            </div>

                            {/* Quick Actions */}
                            <h3 className="dd-card-title dd-quick-title">Quick Actions</h3>
                            <div className="dd-quick-actions">
                                <div className="dd-quick-item">
                                    <Link to="/partners" className="dd-quick-circle">
                                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#7367f0" strokeWidth="2">
                                            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
                                            <circle cx="9" cy="7" r="4" />
                                            <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
                                            <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                        </svg>
                                    </Link>
                                    <span className="dd-quick-label">Explore Partners</span>
                                </div>
                                <div className="dd-quick-item">
                                    <Link to="/billing" className="dd-quick-circle">
                                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#7367f0" strokeWidth="2">
                                            <rect x="2" y="5" width="20" height="14" rx="2" />
                                            <line x1="2" y1="10" x2="22" y2="10" />
                                        </svg>
                                    </Link>
                                    <span className="dd-quick-label">My Transactions</span>
                                </div>
                                <div className="dd-quick-item">
                                    <Link to="/contactussid" className="dd-quick-circle">
                                        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#7367f0" strokeWidth="2">
                                            <circle cx="12" cy="12" r="10" />
                                            <line x1="12" y1="8" x2="12" y2="12" />
                                            <line x1="12" y1="16" x2="12.01" y2="16" />
                                        </svg>
                                    </Link>
                                    <span className="dd-quick-label">Support</span>
                                </div>
                            </div>

                            {/* Footer links */}
                            <div className="dd-card-footer-links">
                                <Link to="/faqsid" className="dd-footer-link">FAQs</Link>
                                <Link to="/securityTerms" className="dd-footer-link">Terms &amp; Privacy</Link>
                            </div>
                        </div>
                    </div>

                    {/* Right Column */}
                    <div className="dd-col-right">
                        {/* Flash Deal Card */}
                        <div className="dd-card dd-flash-card">
                            <div className="dd-flash-header">
                                <span className="dd-flash-label">FLASH DEAL:</span>
                                <div className="dd-flash-icons">
                                    <span className="dd-flash-icon-btn">&#128247;</span>
                                    <span className="dd-flash-icon-btn">&#128203;</span>
                                </div>
                            </div>
                            <p className="dd-flash-body">
                                BodyCraft is offering <strong>40% off</strong> on an Annual Health Checkup! 🏃
                            </p>
                            <button className="dd-primary-btn dd-add-slots-btn">
                                + Addable slots: 1
                            </button>
                        </div>

                        {/* Benefits Summary Card */}
                        <div className="dd-card">
                            <h3 className="dd-card-title">Benefits summary</h3>
                            <ul className="dd-benefits-list">
                                <li>Up to 40% cashback &amp; discounts</li>
                                <li>Valid for all healthcare &amp; wellness partners</li>
                                <li>Benefits vary by service and location</li>
                            </ul>
                            <Link to="/partners" className="dd-explore-link">
                                Explore Partners
                            </Link>
                        </div>

                        {/* My Account Card */}
                        <div className="dd-card">
                            <h3 className="dd-card-title">My Account</h3>
                            <ul className="dd-account-list">
                                <li className="dd-account-item">
                                    <Link to="/updateProfile" className="dd-account-link">
                                        Update Profile
                                        <span className="dd-chevron">&#8250;</span>
                                    </Link>
                                </li>
                                <li className="dd-account-item">
                                    <Link to="/billing" className="dd-account-link">
                                        Update Bank Information
                                        <span className="dd-chevron">&#8250;</span>
                                    </Link>
                                </li>
                                <li className="dd-account-item">
                                    <Link to="/profile" className="dd-account-link">
                                        Notification Preferences
                                        <span className="dd-chevron">&#8250;</span>
                                    </Link>
                                </li>
                                <li className="dd-account-item">
                                    <Link to="/membershipcard" className="dd-account-link">
                                        Download Membership Cards
                                        <span className="dd-chevron">&#8250;</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default DashboardDemo;
